  <template>
  <va-card title="Users">
    <template slot="actions">
      <va-button @click="addNew"> Add new </va-button>
    </template>

    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input class="ma-0" :value="searchTerm" placeholder="Search" @input="search">
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>

    <div v-if="loading" class="hiq-spinner-div">
      <img class="hiq-spinner" src="/assets/rpspinnerb.png" />
    </div>
    <va-data-table
      ref="datatable"
      :fields="fields"
      :data="filteredData"
      :selection-id="currentSelId"
      no-pagination
      @row-clicked="rowClicked"
      clickable
      no-data-label="No users"
      hoverable
      ext-link-field="__slot:extlink"
      v-if="!loading"
      style="height: 40vh;"
    >
      <template slot="is_admin" slot-scope="{ rowData }">{{ prettyIsAdmin(rowData) }}</template>
      <template slot="last_login" slot-scope="{ rowData }">{{ prettyLastLogin(rowData) }}</template>
    </va-data-table>

    <va-modal v-model="showCreateDialog" :noOutsideDismiss="true" :hideDefaultActions="true" title="Create User">
      <form>
        <div class="row">
          <div class="flex xs12">
            <va-select label="Account" v-model="dialogAccountVal" :options="dialogAccountOptions" :clearValue="dialogAccountOptions[0]" :noClear="true" :clearOnMount="false" searchable />
          </div>
        </div>
        <div class="row justify--space-between">
          <div class="flex xs5">
            <va-input v-model="dialogFirstNameVal" label="First Name"></va-input>
          </div>
          <div class="flex xs5">
            <va-input v-model="dialogLastNameVal" label="Last Name"></va-input>
          </div>
        </div>

        <!-- <div class="row">
          <div class="flex xs12">
            <va-input v-model="dialogPassVal" label="Password"></va-input>
          </div>
        </div> -->
        <div class="row">
          <div class="flex xs12">
            <va-input v-model="dialogEmailVal" type="email" label="Email"></va-input>
          </div>
        </div>

        <div class="row">
          <va-checkbox label="Admin" v-model="dialogAdminVal" />
        </div>
      </form>

      <template slot="actions">
        <va-button @click="dialogSave">Create</va-button>
        <va-button @click="dialogCancel">Cancel</va-button>
      </template>
      <span v-if="showSaving">Creating...</span>
      <span style="color: red">{{ errorSaving }}</span>
    </va-modal>
  </va-card>
</template>

<script>
import { debounce } from 'lodash'
import hiqapi from '@/hiqapi/hiqapi'
import { formatDate } from '@/common'

export default {
  data() {
    return {
      loading: true,
      searchTerm: null,
      listData: [], // list of currentListType
      currentSelId: null,

      accountList: [],

      showCreateDialog: false,
      dialogAccountVal: null,
      dialogFirstNameVal: '',
      dialogLastNameVal: '',
      dialogPassVal: '',
      dialogEmailVal: '',
      dialogAdminVal: false,
      showConfirmModal: false,
      showSaving: false,
      errorSaving: '',
    }
  },
  computed: {
    fields() {
      return [
        { name: 'first_name', sortField: 'first_name', title: 'First Name', titleClass: 'text-center' },
        { name: 'last_name', sortField: 'last_name', title: 'Last Name' },
        { name: 'email', sortField: 'email', title: 'Email' },
        { name: '__slot:is_admin', sortField: 'alert_type', title: 'Is Admin', dataClass: 'text-center', titleClass: 'text-center' },
        { name: 'account_name', sortField: 'account_name', title: 'Account', dataClass: 'text-center', titleClass: 'text-center' },
        { name: '__slot:last_login', sortField: 'last_login', title: 'Last Login' },
      ]
    },
    dialogAccountOptions() {
      return this.accountList
    },

    filteredData() {
      let data = this.listData

      if (!this.searchTerm || this.searchTerm.length < 1) {
        return data
      }

      return data.filter((item) => {
        var st = this.searchTerm.toLowerCase()
        return item.first_name.toLowerCase().indexOf(st) !== -1 ||
          item.last_name.toLowerCase().indexOf(st) !== -1 ||
          item.email.toLowerCase().indexOf(st) !== -1 ||
          item.account_name.toLowerCase().indexOf(st) !== -1
      })
    },
  },

  methods: {
    prettyIsAdmin(rowData) {
      if (rowData.is_admin) {
        return 'yes'
      }
      return 'no'
    },

    prettyLastLogin(rowData) {
      return formatDate(rowData.date_last_login)
    },

    addNew() {
      if (this.showCreateDialog) {
        return
      }
      console.log('ADD')
      this.dialogAccountVal = this.dialogAccountOptions[0]
      this.dialogEmailVal = ''
      this.dialogFirstNameVal = ''
      this.dialogLastNameVal = ''
      this.dialogAdminVal = false
      this.showSaving = false
      this.errorSaving = ''
      this.showCreateDialog = true
    },

    async dialogSave() {
      console.log('SAVE ', this.dialogAccountVal.id, this.dialogEmailVal, this.dialogAdminVal)
      this.errorSaving = ''
      this.showSaving = true

      let data = {
        account_id: this.dialogAccountVal.id,
        first_name: this.dialogFirstNameVal,
        last_name: this.dialogLastNameVal,
        password: this.dialogPassVal,
        email: this.dialogEmailVal,
        is_admin: this.dialogAdminVal,
        enabled: true,
      }

      let resp = await hiqapi.postPutWait('post', '/users', data)

      this.showSaving = false

      if (resp.status >= 400) {
        this.errorSaving = resp.data.message
      } else {
        this.showToast('User created', {
          position: 'top-right',
        })

        this.showCreateDialog = false
        this.reload()
      }
    },

    dialogCancel() {
      console.log('CANCEL')
      this.showCreateDialog = false
    },

    rowClicked(item) {
      console.log('**************************************** UserList CLICK ON ', item)
      this.$root.$emit('user_selected', item, null)
    },

    setData(newval) {
      this.loading = false
      this.listData = newval.items
      // Vuetable uses "item_id" to track which row is selected
      this.listData.forEach((item) => {
        item['item_id'] = item['id'].toString()
      })
      this.listData.sort((a, b) => { return (a.first_name > b.first_name) ? 1 : ((b.first_name > a.first_name) ? -1 : 0) })
    },

    setAccountListData(newval) {
      this.accountList = []
      if (!newval) {
        return
      }
      newval.items.forEach((item) => this.accountList.push({ id: '' + item.id, text: item.name }))

      this.accountList.sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0))
    },

    search: debounce(function(searchTerm) {
      this.searchTerm = searchTerm
    }, 400),

    reload() {
      this.isLoading = true
      hiqapi.getcb('/users', this.setData)
      hiqapi.getcb('/accounts', this.setAccountListData)
    },
  },

  mounted() {
    this.$root.$on('reload_user_list', (arg1, arg2) => {
      this.reload()
    })

    this.reload()
  },
}
</script>

<style lang="scss">
.font-awesome-icon {
  color: #bebebe;
}
.hiq-spinner-div {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.hiq-spinner {
  animation-duration: 1.5s;
  animation-timing-function: cubic-bezier(0.54, 0.18, 0.46, 0.82);
  animation-delay: 0s;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  animation-name: spinner-rotation;
}
@keyframes spinner-rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
  }
}
.extlink {
  color: #7596fb;
}
.extlink:hover {
  color: #0c30d3;
}
</style>
